import React, { Component } from 'react';
import moment from 'moment';
import styled from 'styled-components';

const TimerWrapper = styled.div`
  background: #6070fb;
  padding: 0.5em 1em;
  color: white;
  position: fixed;
  align-items: center;
  left: 0;
  top: 0;
  z-index: 100;
  border-radius: 4px;
  button {
    color: white;
    background: #3faf4f;
    border-radius: 4px;
    margin-left: 2em;
    padding: 0.5em 1em;
    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }
`;

export default class TimerDebug extends Component {
  constructor() {
    super();
    this.state = {
      startTime: new Date().getTime(),
      timer: null
    };
    this.timerId;
    this.runTimer = this.runTimer.bind(this);
  }

  componentDidMount() {
    this.runTimer();
  }

  runTimer() {
    const { startTime } = this.state;
    clearInterval(this.timerId);
    this.timerId = setInterval(() => {
      const duration = new Date().getTime() - startTime;
      this.setState({
        timer: moment('2000-01-01 00:00:00')
          .add(moment.duration(duration))
          .format('mm:ss')
      });
    }, 1000);
  }

  render() {
    const { timer } = this.state;
    return (
      <TimerWrapper>
        {timer && <span>{timer}</span>}
        <button
          onClick={() => {
            this.setState({ startTime: new Date().getTime() }, () => {
              this.runTimer();
            });
          }}
        >
          Reset
        </button>
      </TimerWrapper>
    );
  }
}
